export default __webpack_public_path__ + "static/media/goalPageDark@2x.dc0cac42.png";